export class Task {
  shortType!: string;
  id: number;
  title!: string;
  constructor(shortType: string, id: number, title: string) {
    this.shortType = shortType;
    this.title = title;
    this.id = id;
  }
}
